<template>
  <footer class="footer px-4 mt-5">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-xl-6">
          <div class="copyright text-center text-xl-left text-muted">
              &copy; {{year}} Conect Flow <span class="text-xl-left text-muted">v. {{versao}}</span>
          </div>
      </div>
    </div>
  </footer>
</template>
<script>
import config from 'config';
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      versao: config.app.version
    };
  }
};
</script>
<style></style>
